import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import "./BusForm.css";
import moment from "moment";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import BusDatePicker from "./BusDatePicker";
import BusCitySelection from "./BusCitySelection";
import RecentSearch from "../RecentSearch";

const BUS_CACHE_NAME = "bus-search-cache";
const BUS_CACHE_DURATION = 30 * 24 * 60 * 60 * 1000; // 1 month

export const insertBusSearchIntoCache = async (busData) => {
  const cache = await caches.open(BUS_CACHE_NAME);

  const timestampedData = { ...busData, timestamp: Date.now() };

  const response = new Response(JSON.stringify(timestampedData), {
    headers: { "Content-Type": "application/json" },
  });

  // Key pattern: source-destination-date-timestamp
  const cacheKey = `${busData.source}-${busData.destination}-${busData.journeyDate}-${timestampedData.timestamp}`;

  await cache.put(new Request(cacheKey), response);

  // Enforce max 8 searches
  const keys = await cache.keys();
  if (keys.length > 8) {
    const keyDataPairs = await Promise.all(
      keys.map(async (key) => {
        const res = await cache.match(key);
        const data = await res.json();
        return { key, timestamp: data.timestamp };
      })
    );

    keyDataPairs.sort((a, b) => a.timestamp - b.timestamp);

    const deleteKeys = keyDataPairs.slice(0, keys.length - 8);
    for (let { key } of deleteKeys) {
      await cache.delete(key);
    }
  }
};

export const fetchValidBusSearchesFromCache = async () => {
  const cache = await caches.open(BUS_CACHE_NAME);
  const keys = await cache.keys();

  const validSearches = [];

  for (let key of keys) {
    const res = await cache.match(key);
    const data = await res.json();

    if (Date.now() - data.timestamp < BUS_CACHE_DURATION) {
      validSearches.push(data);
    } else {
      await cache.delete(key);
    }
  }

  return validSearches.sort((a, b) => b.timestamp - a.timestamp).slice(0, 8);
};

const BusForm = ({ onSearchComplete }) => {
  const [active2, setActive2] = useState(false);
  const [active3, setActive3] = useState(false);
  const [activeForm, setActiveForm] = useState(false);
  // const [cal, setCal] = useState(false);
  const [active, setActive] = useState(true);

  const handleSearchFlight = () => {
    setActive(true);
    setActive2(false);
    setActive3(false);
    setEndDate(null);
  };

  const [isTravellerInputSelected, setTravellerInputSelected] = useState(false);
  const [isClassInputSelected, setClassInputSelected] = useState(false);
  // const [isWebInputSelected, setWebInputSelected] = useState(false);
  const [isCalenderSelected, setCalenderSelected] = useState(false);
  const [fromCitySelected, setFromCitySelected] = useState(false);
  const [toCitySelected, setToCitySelected] = useState(false);
  const [departureCity, setDepartureCity] = useState({});
  const [arrivalCity, setArrivalCity] = useState({});
  const [destination2, setDestination2] = useState();
  const [destination1, setDestination1] = useState();
  const [quickDate, setQuickDate] = useState(null);

  const handleTravellerInputFocus = () => {
    setTravellerInputSelected(true);
  };
  const handleClassInputFocus = () => {
    setClassInputSelected(true);
  };
  // const handleWebInputFocus = () => {
  //   setWebInputSelected(true);
  // };
  const handleCalenderFocus = (input) => {
    setCalenderSelected(true);
    if (!isCalenderSelected) {
      if (input === "startDate") {
        setFocusedInput("startDate");
      } else if (input === "endDate") {
        setFocusedInput("endDate");
      } else {
        // setStartDate(null);
        // setEndDate(null);
        // setFocusedInput(null);

        setCalenderSelected(!isCalenderSelected);
        if (!isCalenderSelected) setFocusedInput("startDate");
        else setFocusedInput(null);
      }
    }
  };
  // const handleCheckOutFocus = () => {
  //   setCheckOutSelected(true);
  // };
  const handleFromCityClick = () => {
    setFromCitySelected(true);
    // setToCitySelected(false);
  };

  const handleToCityClick = () => {
    // setFromCitySelected(false);
    setToCitySelected(true);
  };

  const closeTravellerInput = () => {
    setTravellerInputSelected(false);
  };
  const closeClassInput = () => {
    setClassInputSelected(false);
  };
  // const closeWebInput = () => {
  //   setWebInputSelected(false);
  // };
  const closeDateInput = () => {
    setCalenderSelected(false);
    // setCheckOutSelected(false);
  };
  const closeCitySelection = () => {
    setFromCitySelected(false);
    setToCitySelected(false);
  };

  const [startDate, setStartDate] = useState(moment().add(1, "days"));

  const [endDate, setEndDate] = useState(
    active2 ? moment().add(2, "days") : null
  );
  useEffect(() => {
    setEndDate(active2 ? moment().add(2, "days") : null);
  }, [active2]);
  const [focusedInput, setFocusedInput] = useState(null);

  const navigate = useNavigate();
  const handleFlightSearch = () => {
    const tripTypeMapping = {
      OneWay: 1,
      RoundTrip: 2,
      MultiCity: 3,
    };
    const tripType = tripTypeMapping[!setActive ? "RoundTrip" : "OneWay"];
  };

  const location = useLocation();
  const [selectedClass, setSelectedClass] = useState(2);

  const handleSwapCities = () => {
    const temp = departureCity;
    setDepartureCity(arrivalCity);
    setArrivalCity(temp);

    const tempDest = destination1;
    setDestination1(destination2);
    setDestination2(tempDest);
  };

  //  Handle search

  const [cacheData, setCacheData] = useState([]);

  useEffect(() => {
    const loadCache = async () => {
      const cached = await fetchValidBusSearchesFromCache();
      setCacheData(cached);
    };
    loadCache();
  }, []);

  console.log("Bus recent search cache:", cacheData);
  // const handleSearch = () => {
  //   if (!departureCity?.name || !arrivalCity?.name || !startDate) {
  //     alert("Please select source, destination and journey date");
  //     return;
  //   }

  //   const query = `?from=${encodeURIComponent(departureCity.name)}&to=${encodeURIComponent(
  //     arrivalCity.name
  //   )}&cityId=${departureCity.code}&desId=${arrivalCity.code}&journeyDate=${startDate.format("YYYY-MM-DD")}`;

  //   navigate(`/buslisting${query}`);

  //       // notify parent to close form
  //     if (onSearchComplete) {
  //       onSearchComplete();
  //     }
  // };

  const handleSearch = async () => {
    if (!departureCity?.name || !arrivalCity?.name || !startDate) {
      alert("Please select source, destination and journey date");
      return;
    }

    const searchData = {
      source: departureCity.name,
      destination: arrivalCity.name,
      sourceId: departureCity.code,
      destinationId: arrivalCity.code,
      journeyDate: startDate.format("YYYY-MM-DD"),
    };

    // ⭐ Insert into bus cache BEFORE navigation
    await insertBusSearchIntoCache(searchData);

    // ⭐ Build url query string
    const query = `?from=${encodeURIComponent(
      searchData.source
    )}&to=${encodeURIComponent(searchData.destination)}&cityId=${
      searchData.sourceId
    }&desId=${searchData.destinationId}&journeyDate=${searchData.journeyDate}`;

    navigate(`/buslisting${query}`);

    // Close popup or form
    if (onSearchComplete) {
      onSearchComplete();
    }
  };

  return (
    <div className="bus_phone_container">
      <div className="tab-content-fs" style={{ marginTop: "15px" }}>
        <div className="pd20_n hotelMobile_pd20">
          <div className="pd10_n">
            <div className="inner_cont">
              <div className="location">
                <i className="_loc-icon" />
              </div>
              <div className="input_bus_mobile m_rel">
                <p className="inpttl">From</p>
                <div
                  className="hl-input"
                  style={{ display: "inline-block" }}
                  onClick={handleFromCityClick}
                >
                  <span id="autofocusfr" className="fare_btn2 fullwid">
                    {departureCity?.name || "Enter City"}
                  </span>
                </div>

                <i
                  className="swap_icn_blank "
                  id="SwapImg"
                  onClick={handleSwapCities}
                />
              </div>
            </div>
          </div>
          <div className="pd10_n">
            <div className="inner_cont">
              <div className="location">
                <i className="_loc-icon" />
              </div>
              <div
                className="input_bus_mobile m_rel"
                onClick={handleToCityClick}
              >
                <p className="inpttl">To</p>
                <div className="hl-input" style={{ display: "inline-block" }}>
                  <span id="autofocusto" className="fullwid ng-binding">
                    {arrivalCity?.name || "Enter City"}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="pd10_n">
            <div className="inner_cont">
              <div className="location">
                <i className="_loc-iconcal" />
              </div>
              <div className="input_bus_mobile m_rel">
                <p className="inpttl">Departure Date</p>
                <div className="hl-input">
                  <div id="ddate" onClick={handleCalenderFocus}>
                    <input
                      readOnly=""
                      type="text"
                      className="hl-input4"
                      id="datepicker"
                      name="datepicker"
                      defaultValue=""
                      required=""
                      placeholder="dd-mm-yyyy"
                      value={startDate ? startDate.format("MM/DD/YYYY") : ""}
                      onClick={handleCalenderFocus}
                    />
                  </div>
                  <div className="_merleft">
                    <a
                      className={`nextday ${
                        quickDate === "tomorrow" ? "active" : ""
                      }`}
                      onClick={() => {
                        setStartDate(moment().add(1, "days"));
                        setQuickDate("tomorrow");
                      }}
                    >
                      Tomorrow
                    </a>
                    <a
                      className={`nextday ${
                        quickDate === "dayafter" ? "active" : ""
                      }`}
                      onClick={() => {
                        setStartDate(moment().add(2, "days"));
                        setQuickDate("dayafter");
                      }}
                    >
                      Day After
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="clr" />
          <div>
            <button
              type="button"
              className="fs_btn _clickbtn"
              onClick={handleSearch}
            >
              Search
            </button>
          </div>
        </div>
        <div style={{ paddingLeft: "10px", color: "#333" }}>
                  {location.pathname === "/" && <RecentSearch cacheData={cacheData} />}
          
         
        </div>
      </div>

      {fromCitySelected && (
        <BusCitySelection
          orname="Origin"
          code={departureCity.code}
          name={departureCity.name}
          setCity={setDepartureCity}
          closeCitySelection={closeCitySelection}
          setDestination2={setDestination2}
          setDestination1={setDestination1}
        />
      )}

      {toCitySelected && (
        <BusCitySelection
          setDestination2={setDestination2}
          setDestination1={setDestination1}
          orname="Destination"
          code={arrivalCity.code}
          name={arrivalCity.name}
          setCity={setArrivalCity}
          closeCitySelection={closeCitySelection}
        />
      )}
      {isCalenderSelected && (
        <BusDatePicker
          closeDateInput={closeDateInput}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          active2={active2}
          focusedInput={focusedInput}
          setFocusedInput={setFocusedInput}
        />
      )}
    </div>
  );
};

export default BusForm;
